export const T = {
  nav_menu: { es: "Menú", en: "Menu" },
  nav_story: { es: "Historia", en: "Story" },
  nav_gallery: { es: "Galería", en: "Gallery" },
  nav_videos: { es: "Videos", en: "Videos" },
  nav_reviews: { es: "Reseñas", en: "Reviews" },
  nav_visit: { es: "Visítanos", en: "Visit" },
  order: { es: "Ordenar ahora", en: "Order now" },
  hero_scroll: { es: "Desliza para explorar", en: "Scroll to explore" },
  menu_kicker: { es: "El Menú", en: "The Menu" },
  menu_title: { es: "Sabor de la calle", en: "Taste of the street" },
  cat_all: { es: "Todo", en: "All" },
  cat_tacos: { es: "Tacos", en: "Tacos" },
  cat_burritos: { es: "Burritos", en: "Burritos" },
  cat_platos: { es: "Platos Fuertes", en: "Plates" },
  cat_antojitos: { es: "Antojitos", en: "Snacks & Extras" },
  story_kicker: { es: "Nuestra Historia", en: "Our Story" },
  gallery_kicker: { es: "Galería", en: "Gallery" },
  gallery_title: { es: "Recién hecho, cada día", en: "Made fresh, every day" },
  sug_kicker: { es: "Los más vendidos", en: "Best sellers" },
  sug_title: { es: "Platillos sugeridos", en: "Signature picks" },
  sug_all: { es: "Ver todo el menú", en: "See full menu" },
  sug_badge: { es: "Más vendido", en: "Best seller" },
  sug_order: { es: "Ver en el menú", en: "View in menu" },
  videos_kicker: { es: "En Vivo", en: "Live" },
  videos_title: { es: "Directo del food truck", en: "Straight from the truck" },
  reviews_kicker: { es: "Reseñas", en: "Reviews" },
  reviews_title: { es: "Lo que dicen", en: "What they say" },
  reviews_on_google: { es: "reseñas en Google", en: "reviews on Google" },
  visit_kicker: { es: "Visítanos", en: "Visit Us" },
  visit_title: { es: "Dónde encontrarnos", en: "Where to find us" },
  address: { es: "Dirección", en: "Address" },
  hours: { es: "Horario", en: "Hours" },
  phone: { es: "Teléfono", en: "Phone" },
  contact_title: { es: "Escríbenos", en: "Get in touch" },
  name: { es: "Nombre", en: "Name" },
  message: { es: "Mensaje", en: "Message" },
  send: { es: "Enviar mensaje", en: "Send message" },
  sent: { es: "¡Mensaje enviado! Te contactaremos pronto.", en: "Message sent! We'll reach out soon." },
  wa_order: { es: "Pedir por WhatsApp", en: "Order via WhatsApp" },
  rights: { es: "Todos los derechos reservados.", en: "All rights reserved." },
  admin: { es: "Acceso", en: "Admin" },
};

export const t = (key, lang) => (T[key] ? T[key][lang] : key);
